export default __webpack_public_path__ + "9d2f445.png";